import React from 'react';
import { motion } from 'framer-motion';

const EmojiPicker = ({ onSelect, onClose }) => {
  const emojis = [
    '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂',
    '🙂', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘',
    '😋', '😛', '😜', '🤪', '😝', '🤗', '🤭', '🤫',
    '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒',
    '🙄', '😬', '🤥', '😌', '😔', '😪', '🤤', '😴',
    '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '🥵', '🥶',
    '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐',
    '😕', '😟', '🙁', '☹️', '😮', '😯', '😲', '😳',
    '🥺', '😦', '😧', '😨', '😰', '😥', '😢', '😭',
    '😱', '😖', '😣', '😞', '😓', '😩', '😫', '🥱',
    '😤', '😡', '😠', '🤬', '👍', '👎', '👏', '🙌',
    '👋', '🤝', '🙏', '💪', '❤️', '🧡', '💛', '💚',
    '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕',
    '💞', '💓', '💗', '💖', '💘', '💝', '🎉', '🎊',
    '🎈', '🎂', '🎁', '🏆', '🥇', '🥈', '🥉', '⭐',
    '✨', '💫', '🌟', '🔥', '💯', '✅', '❌', '🚀'
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/20 flex items-center justify-center z-50 p-4"
      style={{ pointerEvents: 'auto' }}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-3xl shadow-2xl p-6 max-w-md w-full"
        style={{ pointerEvents: 'auto' }}
      >
        <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Pick an Emoji
        </h3>

        <div className="grid grid-cols-8 gap-2 max-h-96 overflow-y-auto">
          {emojis.map((emoji, idx) => (
            <button
              key={idx}
              data-testid={`emoji-${idx}`}
              onClick={() => onSelect(emoji)}
              className="text-2xl hover:scale-125 active:scale-150 transition-transform p-2 rounded-lg hover:bg-black/5"
            >
              {emoji}
            </button>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default EmojiPicker;